// React
import React from 'react';
import config from 'config';
import {connect} from 'react-redux';
import {Modal, Button, Image} from 'react-bootstrap';

//APPs
import Utils from '../../utils/utils';
import ModalApi from '../../api/modal-api';

class ModalComponent extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};

		this.closeClick = this.closeClick.bind(this);
	}

	closeClick() {
		if (this.props.modal.closeClick) this.props.modal.closeClick();
		else ModalApi.hideModal();
	}

	render() {
		return (
			<Modal bsSize={this.props.modal.size} show={this.props.modal.show} onHide={this.closeClick}>

				<Modal.Header closeButton={this.props.modal.closeButton}>
					<Modal.Title id="modal-title">
						{this.props.modal.title}
						{this.props.modal.subTitle &&
							<small><br />{this.props.modal.subTitle}</small>
						}
					</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					{this.props.modal.icon &&
						<Image src={ Utils.getImgPath() + this.props.modal.icon } className="icon" alt=""/>
					}
					{this.props.modal.description}
				</Modal.Body>

				<Modal.Footer>
					{this.props.modal.buttons && this.props.modal.buttons.map((btn, i) =>
						<Button key={i} className={(btn.className) ? 'btn-'+btn.className : ''} onClick={btn.click}>
							{btn.text}
						</Button>
					)}
				</Modal.Footer>

			</Modal>
		);
	}
}

const mapStateToProps = function (store) {
	return {
		modal: store.modalState
	};
};

export default connect(mapStateToProps)(ModalComponent);


// WEBPACK FOOTER //
// ./src/components/shared/modal.component.jsx